


































































































































import Vue from "vue";
import store from "@/store";

// Interfaces
import { didDaysAgo } from "@/interfaces/time.interface";
import { dialogOptions } from "@/interfaces/dialog.interface";
import { userWorkoutTemplate } from "@/interfaces/user.interface";
import { WorkoutTemplateSubmit } from "@/interfaces/workoutTemplate.interface";
import { getBestSetsFromExerciseTemplates } from "@/interfaces/exercise.interface";
import { convertUserWorkoutTemplateToWorkout } from "@/interfaces/workout.interface";

// Components
import WorkoutTemplateDialog from "@/components/dialogs/WorkoutTemplateDialog.vue";

export default Vue.extend({
  props: {
    workoutTemplateData: Object as () => userWorkoutTemplate,
  },
  data: () => {
    return {
      workoutTemplateDialog: false,
      showExtraDetails: false,
      overlay: false,
    };
  },
  methods: {
    startWorkout() {
      store.commit(
        "workoutStore/setCurrentWorkout",
        convertUserWorkoutTemplateToWorkout(this.workoutTemplateData)
      );
      store.commit("workoutStore/changeCurrentWorkoutDialogCollapse", true);
    },
    localDialogController(dialog: dialogOptions) {
      this.workoutTemplateDialog = false;
      if (dialog === "workoutTemplateDialog") this.workoutTemplateDialog = true;
    },
    async duplicateWorkoutTemplate() {
      const data: WorkoutTemplateSubmit = {
        workoutTemplateData: this.workoutTemplateData,
      };
      data.workoutTemplateData.lastDone = null;
      this.overlay = true;

      await store
        .dispatch("templateStore/createWorkoutTemplate", data)
        .then(() => {
          this.overlay = false;
        })
        .catch(() => {
          alert("There was a problem uploading your template :(");
          this.overlay = false;
        });
    },
    async deleteWorkoutTemplate() {
      this.overlay = true;
      await store
        .dispatch(
          "templateStore/deleteWorkoutTemplate",
          this.workoutTemplateData.id
        )
        .then(() => {
          this.overlay = false;
        })
        .catch(() => {
          alert("Could not delete template");
          this.overlay = false;
        });
    },
  },
  computed: {
    didDaysAgoCalculated(): string {
      return didDaysAgo(this.workoutTemplateData.lastDone);
    },
    bestExerciseSets(): string[] {
      return getBestSetsFromExerciseTemplates(
        this.workoutTemplateData.exercises
      );
    },
    isUserCurrentlyWorkingOut(): boolean {
      return store.getters["workoutStore/isUserCurrentlyWorkingOut"];
    },
  },
  components: {
    WorkoutTemplateDialog,
  },
});
